export const EMPTY_VALUE = '-';

export const HEADER_CASE_LABEL = 'Case';

export const CASE_DETAILS_FETCH_FAILED_TEXT = 'Failed to load case details. Please try again.';

export const DOWNLOAD_ALL_LABEL = 'Download All';

export const SEE_LESS_LABEL = 'see less';

export const DOCUMENT_COLLAPSE_LIMIT = 2;

export const moreDocumentsLabel = (count: number) => `+ ${count} more`;

export const OUTCOME_IN_FAVOUR_PREFIX = 'In Favor of';

export const SECTION_TITLES = {
    SUMMARY: 'Case summary',
    STATUS: 'Case Status',
    DETAILS: 'Case Details',
    COURT: 'Court & jurisdiction',
    PETITIONERS: 'Petitioners Details',
    RESPONDENTS: 'Respondents Details',
} as const;

export const ROW_LABELS = {
    CASE_TYPE: 'Case Type',
    CASE_SUMMARY: 'Case Summary',
    PETITIONERS: 'Petitioners',
    RESPONDENTS: 'Respondents',
    ADVOCATE_NAME: 'Advocate Name',
    STATUS: 'Status',
    FILING_DATE: 'Filing Date',
    NEXT_HEARING_DATE: 'Next Hearing Date',
    DECISION_DATE: 'Decision Date',
    CASE_OUTCOME: 'Case Outcome',
    NATURE_OF_DISPOSAL: 'Nature of Disposal',
    STAGE_OF_CASE: 'Stage of Case',
    CASE_DOCUMENTS: 'Case Documents',
    CASE_NUMBER: 'Case Number',
    SEVERITY: 'Severity',
    CINO: 'CINO',
    CIVIL_CRIMINAL: 'Civil / Criminal',
    CASE_THEME: 'Case Theme',
    ACTS_AND_SECTIONS: 'Acts & Sections',
    FIR_DETAILS: 'FIR details',
    COURT: 'Court',
    PRESIDING_JUDGE: 'Presiding Judge',
    COURT_ESTABLISHMENT: 'Court Establishment',
    STATE: 'State',
    DISTRICT: 'District',
} as const;

export const PARTY_NOUN = {
    PETITIONER: 'Petitioner',
    RESPONDENT: 'Respondent',
} as const;

export const PARTY_ROW_SUFFIX = {
    ADDRESS: 'Address',
    ADVOCATE_NAME: 'Advocate Name',
} as const;

export const SECTION_LABEL = 'Section';
